// extracted by mini-css-extract-plugin
export default {"card-creator-sidebar":"card-creator-sidebar--uiuJY","card-creator-sidebar__body":"card-creator-sidebar__body--WOYQ0","card-creator-sidebar__preview":"card-creator-sidebar__preview--jyFy9","card-creator-sidebar__configuration":"card-creator-sidebar__configuration--1LV52"};
    if(module.hot) {
      // 1747648178490
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  